import React from 'react';
import Helpers from 'utils/helpers';
import './flow.css';

function Flow(props) {
  return (
    <div className={Helpers.String.join(['flow', props.className])}>
      {props.children}
    </div>
  );
}

function FlowHeader(props) {
  return (
    <div className={Helpers.String.join(['flow-header', props.className])}>
      {props.children}
    </div>
  );
}

function FlowBody(props) {
  return (
    <div className={Helpers.String.join(['flow-body', props.className])}>
      {props.children}
    </div>
  );
}

function FlowFooter(props) {
  return (
    <div className={Helpers.String.join(['flow-footer', props.className])}>
      {props.children}
    </div>
  );
}

Flow.Header = FlowHeader;
Flow.Body = FlowBody;
Flow.Footer = FlowFooter;

export default Flow;